// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ib-0";
export var animationContainer = "_ib-1";
export var modalContent = "_ib-2";
export var orderName = "_ib-3";
export var refundOption = "_ib-4";
export var refundOptionsContainer = "_ib-5";